export default "__VITE_ASSET__BrtOAsZE__"